export const formatCurrency = Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
}).format

export function formatCurrenctyWithoutSignal(value) {
  const DECIMALS_QUANTITY = 2

  return new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: DECIMALS_QUANTITY,
    maximumFractionDigits: DECIMALS_QUANTITY,
  }).format(value)
}
